import { Sparkles, Droplets, Car, Shield, Armchair, SprayCan } from "lucide-react";

const services = [
  {
    icon: Droplets,
    title: "Exterior Detail",
    price: "$75",
    description: "A multi-stage decontamination featuring Koch Chemie GS, GSF, and PW. This process safely lifts road grime, followed by a deep clean, while leaving behind a high-gloss, water-repellent finish. We deep-clean the wheels and tires, finishing with a streak-free glass treatment for maximum clarity.",
  },
  {
    icon: Car,
    title: "Interior Detail",
    price: "$110",
    description: "A complete interior reset. We perform a deep vacuuming and specialized pet hair removal to ensure every fiber is clear. Using Blackline Reset, we meticulously clean all surfaces to a factory-matte finish. Finally, we use our premium glass cleaner to ensure every window is left with 100% optical clarity.",
  },
  {
    icon: Sparkles,
    title: "Full Detail",
    price: "$180",
    description: "Our flagship \"top-to-bottom\" service. We combine our precision exterior foam-wash and protection treatment with a surgical interior overhaul. From the wheel barrels to the sun visors, every inch of your vehicle is addressed, cleaned, and refreshed to a showroom standard.",
  },
];

const additions = [
  {
    icon: Shield,
    title: "Fabric Protection",
    price: "$12",
    description: "(Gtechniq Smart Fabric v3): An advanced nanotechnology barrier for your seats and carpets. This makes fabrics \"breathable\" but highly hydrophobic — liquids simply bead off the surface instead of soaking in.",
  },
  {
    icon: Armchair,
    title: "Leather Conditioning",
    price: "$10",
    description: "Koch Chemie LS: A premium leather conditioner that restores suppleness and provides a natural, non-greasy satin finish with built-in UV protection.",
  },
  {
    icon: SprayCan,
    title: "Quick Shine Sealant",
    price: "$10",
    description: "Koch Chemie QS: An intensive finishing spray that cleans, maintains, and protects all smooth surfaces, providing a deep, streak-free gloss and a smooth-as-glass feel.",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#737373] mb-4">What We Offer</p>
          <h2
            data-testid="services-heading"
            className="text-3xl sm:text-4xl tracking-tight font-bold uppercase text-white"
          >
            Our Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="border border-[#262626] bg-[#0A0A0A] p-8 bento-card group"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="w-10 h-10 flex items-center justify-center border border-[#333333] mb-6 group-hover:border-white transition-colors duration-300">
                  <Icon size={20} className="text-[#A3A3A3] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-semibold tracking-tight text-white mb-1">{service.title}</h3>
                {service.price && <p className="text-lg font-bold text-white mb-3">{service.price}</p>}
                <p className="text-sm leading-relaxed text-[#A3A3A3]">{service.description}</p>
              </div>
            );
          })}
        </div>

        {/* Additions */}
        <div className="text-center mt-20 mb-12">
          <h2
            data-testid="additions-heading"
            className="text-3xl sm:text-4xl tracking-tight font-bold uppercase text-white"
          >
            Additions
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {additions.map((addition, i) => {
            const Icon = addition.icon;
            return (
              <div
                key={addition.title}
                data-testid={`addition-card-${addition.title.toLowerCase().replace(/\s+/g, '-')}`}
                className="border border-[#262626] bg-[#0A0A0A] p-8 bento-card group"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="w-10 h-10 flex items-center justify-center border border-[#333333] mb-6 group-hover:border-white transition-colors duration-300">
                  <Icon size={20} className="text-[#A3A3A3] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-semibold tracking-tight text-white mb-1">{addition.title}</h3>
                {addition.price && <p className="text-lg font-bold text-white mb-3">{addition.price}</p>}
                <p className="text-sm leading-relaxed text-[#A3A3A3]">{addition.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
